import { render, staticRenderFns } from "./AdministrativeCenterFB2B.vue?vue&type=template&id=b136296e&scoped=true"
import script from "./AdministrativeCenterFB2B.vue?vue&type=script&lang=js"
export * from "./AdministrativeCenterFB2B.vue?vue&type=script&lang=js"
import style0 from "./AdministrativeCenterFB2B.vue?vue&type=style&index=0&id=b136296e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b136296e",
  null
  
)

export default component.exports